<template>
  <div class="content router-content flex items-stretch text-white">
    <template v-for="route in constantRoutes">
      <div
        v-if="!route.hidden"
        :key="route.path"
        class="router-item flex items-center flex-grow"
      >
        <!-- 外链 -->
        <a
          v-if="route.meta.isLink"
          class="w-full h-full flex items-center justify-center text-lg"
          :href="route.path"
          target="_blank"
          >{{ route.meta.title }}</a
        >

        <!-- 本地路由 -->
        <!-- 无子路由 -->
        <router-link
          v-else-if="!route.children || route.children.length === 0"
          class="w-full h-full flex items-center justify-center text-lg"
          :to="route.path"
          :exact="route.path === '/'"
        >
          {{ route.meta.title }}
        </router-link>

        <dropdown v-else class="w-full h-full flex items-center">
          <a
            v-if="route.meta.unPath"
            href="javascript:void(0);"
            class="w-full h-full flex items-center justify-center text-white text-lg"
          >
            {{ route.meta.title }}
          </a>
          <router-link
            v-else
            class="w-full h-full flex items-center justify-center text-white text-lg"
            :to="route.path"
            :exact="route.path === '/'"
          >
            {{ route.meta.title }}
          </router-link>
          <dropdown-menu slot="dropdown">
            <template v-for="item in route.children">
              <dropdown-item
                v-if="!item.hidden"
                :key="item.path"
                class="flex items-center justify-center text-lg"
                @click.native="handleRoutePush(item)"
              >
                {{ item.meta.title }}
              </dropdown-item>
            </template>
          </dropdown-menu>
        </dropdown>
      </div>
    </template>
  </div>
</template>
<script>
import { constantRoutes } from "@/router/index";
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import cloneDeep from "lodash/cloneDeep";

const _constantRoutes = cloneDeep(constantRoutes);

export default {
  name: "TabHeader",
  components: {
    Dropdown,
    DropdownMenu,
    DropdownItem,
  },
  data() {
    return {
      constantRoutes: Object.freeze(_constantRoutes),
    };
  },
  methods: {
    handleRoutePush(route) {
      if (route.meta.unPath) return;

      if (this.$route.name === route.name) return;

      if (route.meta.isLink) {
        return window.open(route.path);
      }

      this.$router.push({ name: route.name });
    },
  },
};
</script>
<style lang="scss" scoped>
.router-content {
  height: 50px;
  .router-item {
    max-width: 200px;
    transition: all 0.3s;
    &:hover {
      background-color: rgba(47, 173, 106, 1);
    }
    .router-link-active {
      background-color: rgba(47, 173, 106, 1);
    }
  }
}
.flex-grow {
  flex: 1;
}
</style>
